import {BudgetExplorer} from "./budget_explorer"
import {StyleExplorer} from "./style_explorer"
import {AltCategoryCta} from "./alt_category_cta"
import {ReviewsSlider} from "./reviews_slider"
import {setupInstagram} from "./instagram"
import {OnVisibleObserver} from "./visibility_observer"

document.addEventListener("DOMContentLoaded", function() {
  BudgetExplorer(document.getElementById('budget-explorer-app'))
  StyleExplorer(document.getElementById('style-app-container'))
  AltCategoryCta()
  ReviewsSlider(document.querySelector("section#customer-reviews"))
  setupInstagram()

  const visibleHandler = new OnVisibleObserver({rootMargin: '-150px'})
  Array.from(document.querySelectorAll(".trigged-on-scroll")).forEach(n => {
    visibleHandler.handle(n, n => {
      n.classList.add("in-view")

      Array.from(n.querySelectorAll("video[data-lazy]")).forEach(video => {
        Array.from(video.querySelectorAll("source")).forEach(sourceEl => sourceEl.src = sourceEl.dataset.src)
        video.load()
        video.play().catch(() => {/*nop*/})
      })
    })
  })
})
